module.exports = __webpack_public_path__ + "static/yellow_sapphire-45dc6fd4391c83eaf293cd17f101e45a.svg";